import React, { useMemo } from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, RequiredValidator, Round } from '../../Components/Form';
import { useSelectable } from '../../Components/Selectable';
import { plural } from '../../Services/helpers';
import { useAddToRoundMany } from '../../Data/Jobs';
import Alert from '../../Components/Alert';

const AddToRoundMany = ({isOpen, onClose, then}) => {
    const {selected} = useSelectable();
    const title = `Adding ${plural(selected.length, '0 jobs', '1 job', `${selected.length} jobs`)} to round`;

    return <Modal title={title} isOpen={isOpen} setIsOpen={onClose} dismissible>
        {isOpen && <Inner then={then} />}
    </Modal>
}

const Inner = ({then}) => {
    const {selected} = useSelectable();
    const addToRound = useAddToRoundMany();

    const formattedIds = useMemo(() => {
        return selected.map(id => {
            const x = id.split('-');
            return {customerId: x[0], jobId: x[1]}
        })
    }, [selected]);

    return <Form
            data={{ids: formattedIds}}
            onSubmit={addToRound}
            afterSubmit={then}
            closeModalOnSubmit
        >

        <Alert theme="info" message="Jobs can only be in one round, so they'll be removed from any round they're currently in" />

        <Round name="roundId" label="Round" noRoundSelectedLabel="- Select -" validators={[RequiredValidator]} />
        <Actions submit={{label: 'Done'}} cancel />
    </Form>
}

export default AddToRoundMany;
